<template>
  <div>
    <router-view class="router-view" />
    <van-tabbar placeholder fixed route active-color="#C70505" v-model="active">
      <van-tabbar-item replace to="/">
        <span>首页</span>
        <img slot="icon" slot-scope="props" :src="props.active ? icon.active : icon.inactive" />
      </van-tabbar-item>
      <van-tabbar-item replace to="/about">
        <span>我的</span>
        <img
          slot="icon"
          slot-scope="props"
          :src="props.active ? icon.useractive : icon.userinactive"
        />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      icon: {
        active: require("../assets/img/icon-home.png"),
        inactive: require("../assets/img/icon-home-n.png"),
        useractive: require("../assets/img/icon-user.png"),
        userinactive: require("../assets/img/icon-user-n.png"),
      },
    };
  },
};
</script>

<style scoped>
.router-view {
  padding: 0px 0px;
  width: 100%;
  position:absolute;
  height:calc(100% - 50px);
  overflow-y: auto;
}
.bottom-nav {
  color: #c70505;
}
</style>